import React from 'react';

import '../../../styles/base/_toggleType.scss';

const ToggleType = props => {
  const {
    toggle,
    cbk,
    offer,
    showSharpPoint = false,
    firstText,
    lastText,
  } = props;

  const getTooglePlan = () => {
    cbk(!toggle);
  };

  return (
    <div className="toggleBtnSection">
      <span className={`toggleText rightPad ${!toggle ? 'activeToogle' : ''}`}>
        {firstText}
      </span>
      <div className="toogleSequence">
        <div className="toogleButton">
          <input
            type="checkbox"
            className="toggleCheckbox"
            checked={toggle}
            onChange={getTooglePlan}
          />
          <div className="knobs" />
          <div className="layer" />
        </div>
      </div>
      <span className={`toggleText leftPad ${toggle ? 'activeToogle' : ''}`}>
        {lastText}
      </span>
      {offer && (
        <span className="offerBadge">
          {showSharpPoint && <span className="sharp-point" />}
          {offer}% OFF
        </span>
      )}
    </div>
  );
};

export { ToggleType };
export default ToggleType;
